import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IMIconType } from './typings';

@Component({
  selector: 'm-file-display-icon',
  template: `
    <ng-container [ngSwitch]="mType">
      <i nz-icon *ngSwitchCase="'success'">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="success" transform="translate(-1160.000000, -587.000000)" fill="#21BC29">
              <g id="编组-16" transform="translate(224.000000, 72.000000)">
                <g id="-mockplus-" transform="translate(200.000000, 499.000000)">
                  <g id="-mockplus-" transform="translate(736.000000, 16.000000)">
                    <g id="6.Public全局/图标/Line/close" transform="translate(1.000000, 1.000000)">
                      <path
                        d="M2.05025254,2.05025254 C4.78392258,-0.683417512 9.21607744,-0.683417512 11.9497475,2.05025254 C14.6834175,4.78392258 14.6834175,9.21607744 11.9497475,11.9497475 C9.21607744,14.6834175 4.78392258,14.6834175 2.05025254,11.9497475 C-0.683417512,9.21607744 -0.683417512,4.78392258 2.05025254,2.05025254 Z M11.024526,2.59983944 C8.68474334,0.456567575 5.049293,0.517803914 2.78354846,2.78354846 C0.454866565,5.11223035 0.454866565,8.88776967 2.78354846,11.2164516 C5.11223035,13.5451334 8.88776967,13.5451334 11.2164516,11.2164516 C13.5451334,8.88776967 13.5451334,5.11223035 11.2164516,2.78354846 L11.2164516,2.78354846 Z M10.5717472,4.14814815 L11.2465146,4.82291553 L5.90646718,10.162963 L3.11111111,7.36763207 L3.78587546,6.69286166 L5.90583584,8.81289546 L10.5717472,4.14814815 Z"
                        id="形状结合"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="'exception'">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="exception" transform="translate(-1162.000000, -444.000000)">
              <g id="编组-16" transform="translate(224.000000, 72.000000)">
                <g id="-mockplus-" transform="translate(200.000000, 355.000000)">
                  <g id="6.Public全局/图标/Line/close" transform="translate(738.000000, 17.000000)">
                    <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                    <path
                      d="M3.05025254,3.05025254 C5.78392258,0.316582488 10.2160774,0.316582488 12.9497475,3.05025254 C15.6834175,5.78392258 15.6834175,10.2160774 12.9497475,12.9497475 C10.2160774,15.6834175 5.78392258,15.6834175 3.05025254,12.9497475 C0.316582488,10.2160774 0.316582488,5.78392258 3.05025254,3.05025254 Z M12.024526,3.59983944 C9.68474334,1.45656757 6.049293,1.51780391 3.78354846,3.78354846 C1.45486657,6.11223035 1.45486657,9.88776967 3.78354846,12.2164516 C6.11223035,14.5451334 9.88776967,14.5451334 12.2164516,12.2164516 C14.5451334,9.88776967 14.5451334,6.11223035 12.2164516,3.78354846 L12.2164516,3.78354846 Z M10.2915498,4.97515433 L11.0248457,5.70845025 L8.73318519,8.00000001 L11.0248457,10.2915498 L10.2915498,11.0248457 L8.00000001,8.73318519 L5.70845025,11.0248457 L4.97515433,10.2915498 L7.26681482,8.00000001 L4.97515433,5.70845025 L5.70845025,4.97515433 L8.00000001,7.26681482 L10.2915498,4.97515433 Z"
                      id="形状结合"
                      fill="#EE5144"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="'encryption'">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="encryption" transform="translate(-1162.000000, -347.000000)" fill="#EE5144">
              <g id="编组-16" transform="translate(224.000000, 72.000000)">
                <g id="-mockplus-" transform="translate(200.000000, 259.000000)">
                  <g id="-mockplus-" transform="translate(738.000000, 16.000000)">
                    <g id="Icon/Line/universal/lock" transform="translate(2.000000, 1.000000)">
                      <path
                        d="M5.52631579,0 C7.35757575,0 8.84210526,1.48452951 8.84210526,3.31578947 L8.842,5.526 L11.4210526,5.52631579 L11.4210526,14 L-4.26325641e-14,14 L-4.26325641e-14,5.52631579 L2.21,5.526 L2.21052632,3.31578947 C2.21052632,1.48452951 3.69505583,0 5.52631579,0 Z M10.3157895,6.63157895 L1.10526316,6.63157895 L1.10526316,12.8947368 L10.3157895,12.8947368 L10.3157895,6.63157895 Z M5.52631579,8.28947368 C6.23847244,8.28947368 6.81578947,8.86679072 6.81578947,9.57894737 C6.81578947,10.291104 6.23847244,10.8684211 5.52631579,10.8684211 C4.81415914,10.8684211 4.23684211,10.291104 4.23684211,9.57894737 C4.23684211,8.86679072 4.81415914,8.28947368 5.52631579,8.28947368 Z M5.52631579,9.39473684 C5.42457913,9.39473684 5.34210526,9.4772107 5.34210526,9.57894737 C5.34210526,9.68068403 5.42457913,9.76315789 5.52631579,9.76315789 C5.62805245,9.76315789 5.71052632,9.68068403 5.71052632,9.57894737 C5.71052632,9.4772107 5.62805245,9.39473684 5.52631579,9.39473684 Z M5.52631579,1.10526316 C4.36096854,1.10526316 3.40623855,2.00702282 3.32185266,3.1508153 L3.31578947,3.31578947 L3.31578947,5.52631579 L7.73684211,5.52631579 L7.73684211,3.31578947 C7.73684211,2.15044223 6.83508244,1.19571223 5.69128996,1.11132634 L5.52631579,1.10526316 Z"
                        id="形状结合"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="'close'">
        <svg
          width="14px"
          height="14px"
          viewBox="0 0 14 14"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="delete" transform="translate(-738.000000, -17.000000)">
              <g id="6.Public全局/图标/Line/close" transform="translate(738.000000, 17.000000)">
                <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="14" height="14"></rect>
                <polygon
                  id="路径"
                  fill="#8C8C8C"
                  points="11.1247895 2.25649201 11.743508 2.87521044 7.61775 7 11.743508 11.1247895 11.1247895 11.743508 7 7.61775 2.87521044 11.743508 2.25649201 11.1247895 6.381375 7 2.25649201 2.87521044 2.87521044 2.25649201 7 6.381375"
                ></polygon>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="'edit'">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="edit" transform="translate(-1138.000000, -348.000000)">
              <g id="编组-16" transform="translate(224.000000, 72.000000)">
                <g id="-mockplus-" transform="translate(200.000000, 259.000000)">
                  <g id="Icon/Line/universal/lock" transform="translate(714.000000, 17.000000)">
                    <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                    <path
                      d="M14.25,13 L14.25,14 L1.75,14 L1.75,13 L14.25,13 Z M10.024108,1.31739149 L12.7590775,4.0523609 L5.50070206,11.3107363 L2.58265232,11.4331267 L2.76573264,8.57576691 L10.024108,1.31739149 Z M10.0237326,2.73054036 L3.76573264,8.98854036 L3.58265232,10.43246 L5.08626194,10.3100697 L11.3442619,4.05206966 L10.0237326,2.73054036 Z"
                      id="形状结合"
                      fill="#8C8C8C"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
    </ng-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MFileIconComponent {
  @Input() mType: IMIconType = 'success';
}
